import React, {useState} from 'react';


export const useDates = () =>{
    const [date, setDate] = useState({from_date:'', to_date:''});
    const handleChangeDate = (event) =>{
        const {value, name} = event.target;
        setDate({...date,[name]:value})
    }

    return [date, handleChangeDate, setDate]
}